<template>
  <b-modal
    no-close-on-backdrop
    centered
    ok-only
    size="lg"
    v-model="open"
    :title="`Permissões para o colaborador - ${nameClerk}`"
    hide-footer
    :busy="loading"
  >
    <b-row v-if="loading">
      <b-col cols="12" class="text-center">
        <b-spinner label="Spinning"></b-spinner>
      </b-col>
    </b-row>

    <div v-else>
      <b-row class="container text-center mt-3">
        <b-col cols="12">
          <h5 class="text-center">
            Selecione as permissões(leitura ou acesso total) abaixo para o
            colaborador
          </h5>
          <h6 class="mt-3">
            <strong>Visualizar</strong> - o colaborador vai apenas visualizar os
            dados não podendo editar
          </h6>
          <h6>
            <strong>Todos</strong> - o colaborador vai poder visualizar e editar
            os dados
          </h6>
        </b-col>
      </b-row>

      <b-row class="container mt-4">
        <b-col cols="12">
          <div v-for="(item, index) in menuPermission" :key="index">
            <select-permission-component
              :namePermission="item.name"
              :description="item.description"
              :selectPermission="item.selected"
              :checkPermission="item.checked"
              :keyValue="item.key"
              :error="item.error"
              :icon="item.icon"
              @permissionSelect="permissionSelect($event, index)"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" sm="6" class="mt-4">
          <b-button @click="closeModal()" variant="danger" block>
            Fechar
          </b-button>
        </b-col>

        <b-col cols="12" sm="6" class="mt-4">
          <b-button block @click="save()" variant="success"> Salvar </b-button>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
import makeToast from '@/mixins/makeToast';
import SelectPermissionComponent from '@/components/clerk/SelectPermissionComponent.vue';
import UserTypes from '@/enums/UserTypes';

export default {
  components: { SelectPermissionComponent },
  name: 'ModalPermissionClerk',
  mixins: [makeToast],
  emits: ['clerkUpdate'],

  data() {
    return {
      loading: false,
      open: false,
      idUser: '',
      nameClerk: '',
      error: [],
      menuPermission: [],
      menuPermissionDefault: [
        {
          key: 'inicio',
          name: 'Tela Inicio',
          description:
            'Lojista permite se o colaborador vai ter acesso a todos os pedidos ou só os dele',
          selected: 0,
          checked: false,
          icon: 'fas fa-home',
          error: false,
        },
        {
          key: 'estatistica',
          name: 'Tela Estatística',
          description:
            'Lojista permite se o colaborador vai ter acesso a todos os pedidos ou só os dele',
          selected: 0,
          checked: false,
          icon: 'fas fa-chart-line',
          error: false,
        },
        {
          key: 'pedidos',
          name: 'Pedidos App',
          description:
            'Lojista permite se o colaborador vai ter acesso a todos os pedidos ou só os dele',
          selected: 0,
          checked: false,
          icon: 'fas fa-list-alt',
          error: false,
        },
        {
          key: 'pedidoStatus',
          name: 'Pedidos App - Status',
          description:
            'Lojista permite se o colaborador pode mudar o status de todos os pedidos, só o dele ou nenhum',
          selected: 0,
          checked: false,
          icon: 'fas fa-list-alt',
          error: false,
        },
        {
          key: 'carrinhoAbandonado',
          name: 'Carrinho Abandonado App',
          description:
            'Lojista permite se o colaborador vai ter acesso a todos os pedidos ou só os dele',
          selected: 0,
          checked: false,
          icon: 'fas fa-cart-plus',
          error: false,
        },
        {
          key: 'balconista',
          name: 'Vendedor App',
          description:
            'Lojista permite o colaborador visualizar os demais colaborador, adicionar ou cadastrar novos colaborador',
          selected: 0,
          checked: false,
          icon: 'fas fa-user-tie',
          error: false,
        },
        {
          key: 'tipoCliente',
          name: 'Tipos de clientes',
          description:
            'Lojista permite se o colaborador vai ter acesso a visualizar ou editar os tipos de clientes',
          selected: 0,
          checked: false,
          icon: 'fas fa-users-cog',
          error: false,
        },
        {
          key: 'selecionarProduto',
          name: 'Produtos – Selecionar produtos',
          description:
            'Lojista permite se o colaborador vai ter acesso a visualizar ou incluir produtos',
          selected: 0,
          checked: false,
          icon: 'fas fa-tasks',
          error: false,
        },
        {
          key: 'produtoSelecionado',
          name: 'Produtos – Selecionados',
          description:
            'Lojista permite se o colaborador vai ter acesso a visualizar ou incluir produtos',
          selected: 0,
          checked: false,
          icon: 'fas fa-check-double',
          error: false,
        },
        {
          key: 'criarProduto',
          name: 'Produtos – Criar produtos',
          description: 'Só aparecer ou não',
          selected: 0,
          checked: false,
          icon: 'fas fa-box',
          error: false,
        },
        {
          key: 'sugerirProduto',
          name: 'Produtos – Sugerir produtos',
          description: 'Só aparecer ou não',
          selected: 0,
          checked: false,
          icon: 'fas fa-lightbulb',
          error: false,
        },
        {
          key: 'meioPagamento',
          name: 'Meios de pagamento',
          description:
            'Lojista permite se o colaborador vai ter acesso a visualizar ou salvar as informações',
          selected: 0,
          checked: false,
          icon: 'fas fa-credit-card',
          error: false,
        },
        {
          key: 'customizacaoEmpresa',
          name: 'Customizações – Sobre a empresa',
          description:
            'Lojista permite se o colaborador vai ter acesso a visualizar ou salvar as informações',
          selected: 0,
          checked: false,
          icon: 'fas fa-align-left',
          error: false,
        },
        {
          key: 'customizacaoCor',
          name: 'Customizações – Mudar cor',
          description:
            'Lojista permite se o colaborador vai ter acesso a visualizar ou salvar as informações',
          selected: 0,
          checked: false,
          icon: 'fas fa-palette',
          error: false,
        },
        {
          key: 'customizacaoBanner',
          name: 'Customizações – Banner',
          description:
            'Lojista permite se o colaborador vai ter acesso a visualizar ou incluir banner',
          selected: 0,
          checked: false,
          icon: 'fas fa-image',
          error: false,
        },
        {
          key: 'customizacaoHome',
          name: 'Customizações – Oferta(s) home',
          description:
            'Lojista permite se o colaborador vai ter acesso a visualizar ou incluir categorias e produtos',
          selected: 0,
          checked: false,
          icon: 'fas fa-align-justify',
          error: false,
        },
        {
          key: 'promocoesDigitais',
          name: 'Promoções digítais',
          description:
            'Lojista permite se o colaborador vai ter acesso a visualizar ou incluir promoções digítais',
          selected: 0,
          checked: false,
          icon: 'fas fa-ad',
          error: false,
        },
        {
          key: 'pixelFacebook',
          name: 'Pixel Facebook',
          description:
            'Lojista permite se o colaborador vai ter acesso a visualizar ou incluir pixel do Facebook',
          selected: 0,
          checked: false,
          icon: 'fab fa-facebook',
          error: false,
        },
        {
          key: 'ferramentasAnalise',
          name: 'Ferramentas Analise',
          description:
            'Lojista permite se o colaborador vai ter acesso a visualizar ou incluir ferramentas de análise',
          selected: 0,
          checked: false,
          icon: 'fab fa-google',
          error: false,
        },
        {
          key: 'customizacaoSocial',
          name: 'Customizações – Contato e redes sociais',
          description:
            'Lojista permite se o colaborador vai ter acesso a visualizar ou editar as informações',
          selected: 0,
          checked: false,
          icon: 'fas fa-hashtag',
          error: false,
        },
        {
          key: 'frete',
          name: 'Frete e Entrega',
          description:
            'Lojista permite se o colaborador vai ter acesso a todos os pedidos ou só os dele',
          selected: 0,
          checked: false,
          icon: 'fas fa-truck',
          error: false,
        },
        {
          key: 'notificacao',
          name: 'Notificações',
          description:
            'ojista permite se o colaborador vai ter acesso a visualizar ou inserir notificações',
          selected: 0,
          checked: false,
          icon: 'fas fa-bell',
          error: false,
        },
        {
          key: 'solicitacaoProfissional',
          name: 'Solicitações de profissionais',
          description:
            'Lojista permite se o colaborador vai ter acesso a visualizar ou editar as informações',
          selected: 0,
          checked: false,
          icon: 'fas fa-user-tie',
          error: false,
        },
        {
          key: 'sorteioBalconista',
          name: 'Sorteio',
          description:
            'Lojista permite se o colaborador vai ter acesso a visualizar ou editar as informações do sorteio',
          selected: 0,
          checked: false,
          icon: 'fas fa-dice',
          error: false,
        },
        {
          key: 'relatorioFacebookAds',
          name: 'Relatório Facebook ADS',
          description:
            'Lojista permite se o colaborador vai ter acesso a visualizar as informações do Facebook ADS',
          selected: 0,
          checked: false,
          icon: 'fas fa-hashtag',
          error: false,
        },
        {
          key: 'relatorioGoogleAnalytics',
          name: 'Relatório Google Analytics',
          description:
            'Lojista permite se o colaborador vai ter acesso a visualizar as informações do Google Analytics',
          selected: 0,
          checked: false,
          icon: 'fas fa-globe',
          error: false,
        },
        {
          key: 'relatorioQtdClicksWhatsApp',
          name: 'Relatório Qtd. clicks no WhatsApp',
          description:
            'Lojista permite se o colaborador vai ter acesso a visualizar as informações de Qtd. clicks no WhatsApp',
          selected: 0,
          checked: false,
          icon: 'fab fa-whatsapp',
          error: false,
        },
        {
          key: 'relatorioQtdClicksContatos',
          name: 'Relatório Qtd. clicks contato',
          description:
            'Lojista permite se o colaborador vai ter acesso a visualizar as informações de Qtd. clicks contato',
          selected: 0,
          checked: false,
          icon: 'fas fa-share-alt',
          error: false,
        },
        {
          key: 'integrationMarketplaces',
          name: 'Integrações com Marketplaces',
          description:
            'Lojista permite se o colaborador vai ter acesso a visualizar as informações de Integrações com Marketplaces',
          selected: 0,
          checked: false,
          icon: 'fas fa-store',
          error: false,
        },
        {
          key: 'integrationErp',
          name: 'Integrações com ERPs',
          description:
            'Lojista permite se o colaborador vai ter acesso a visualizar as informações de Integrações com ERPs',
          selected: 0,
          checked: false,
          icon: 'fas fa-laptop-house',
          error: false,
        },
        {
          key: 'integrationTiny',
          name: 'Integração com a Tiny',
          description:
            'Lojista permite se o colaborador vai ter acesso a visualizar as informações de Integração com a Tiny',
          selected: 0,
          checked: false,
          icon: 'fas fa-sync',
          error: false,
        },
        {
          key: 'integrationGoogleShopping',
          name: 'Integração com Google Shopping',
          description:
            'Lojista permite se o colaborador vai ter acesso a visualizar as informações de Integração com Google Shopping',
          selected: 0,
          checked: false,
          icon: 'fas fa-tags',
          error: false,
        },
        {
          key: 'verApp',
          name: 'Ver App',
          description:
            'Lojista permite se o colaborador vai ter acesso a visualizar as informações de Ver App',
          selected: 0,
          checked: false,
          icon: 'fas fa-mobile-alt',
          error: false,
        },
        {
          key: 'cadastrarProduto',
          name: 'Cadastrar Produto',
          description:
            'Lojista permite se o colaborador vai ter acesso a visualizar as informações de Cadastrar Produto',
          selected: 0,
          checked: false,
          icon: 'fas fa-box-open',
          error: false,
        },
        {
          key: 'produtosComprados',
          name: 'Produtos Comprados',
          description:
            'Lojista permite se o colaborador vai ter acesso a visualizar as informações de Produtos Comprados',
          selected: 0,
          checked: false,
          icon: 'fas fa-cart-plus',
          error: false,
        },
        {
          key: 'produtosBuscados',
          name: 'Produtos Buscados',
          description:
            'Lojista permite se o colaborador vai ter acesso a visualizar as informações de Produtos Buscados',
          selected: 0,
          checked: false,
          icon: 'fas fa-search',
          error: false,
        },
        {
          key: 'impulsionarProdutos',
          name: 'Impulsionar Produtos',
          description:
            'Lojista permite se o colaborador vai ter acesso a visualizar as informações de Impulsionar Produtos',
          selected: 0,
          checked: false,
          icon: 'fas fa-rocket',
          error: false,
        },
        {
          key: 'servicos',
          name: 'Serviços',
          description:
            'Lojista permite se o colaborador vai ter acesso a visualizar as informações de Serviços',
          selected: 0,
          checked: false,
          icon: 'fas fa-tools',
          error: false,
        },
        {
          key: 'clientesInfo',
          name: 'Clientes',
          description:
            'Lojista permite se o colaborador vai ter acesso a visualizar as informações de Clientes',
          selected: 0,
          checked: false,
          icon: 'fas fa-users',
          error: false,
        },

        // Deixei comentado, pois precisa ajustar as paginas para as permissões funcionarem
        // Procurar pela key para encontrar as paginas mais facilmente
        // {
        //   key: 'aguardandoProdutos',
        //   name: "Aguardando Produtos",
        //   description: "Lojista permite se o colaborador vai ter acesso a visualizar as informações de Aguardando Produtos",
        //   selected: 0,
        //   checked: false,
        //   icon: 'fas fa-hourglass-half',
        //   error: false
        // },
        // {
        //   key: 'editarCategoria',
        //   name: "Editar Categoria",
        //   description: "Lojista permite se o colaborador vai ter acesso a visualizar as informações de Editar Categoria",
        //   selected: 0,
        //   checked: false,
        //   icon: 'fas fa-edit',
        //   error: false
        // },
        // {
        //   key: 'gradeProduto',
        //   name: "Grade Produto",
        //   description: "Lojista permite se o colaborador vai ter acesso a visualizar as informações de Grade Produto",
        //   selected: 0,
        //   checked: false,
        //   icon: 'fas fa-th-large',
        //   error: false
        // },
        // {
        //   key: 'funcionamento',
        //   name: "Funcionamento",
        //   description: "Lojista permite se o colaborador vai ter acesso a visualizar as informações de Funcionamento",
        //   selected: 0,
        //   checked: false,
        //   icon: 'fas fa-clock',
        //   error: false
        // },
        // {
        //   key: 'panfletos',
        //   name: "Panfletos",
        //   description: "Lojista permite se o colaborador vai ter acesso a visualizar as informações de Panfletos",
        //   selected: 0,
        //   checked: false,
        //   icon: 'fas fa-book-open',
        //   error: false
        // },
        // {
        //   key: 'destaques',
        //   name: "Destaques",
        //   description: "Lojista permite se o colaborador vai ter acesso a visualizar as informações de Destaques",
        //   selected: 0,
        //   checked: false,
        //   icon: 'fas fa-hashtag',
        //   error: false
        // },
        // {
        //   key: 'meusLinks',
        //   name: "Meus Links",
        //   description: "Lojista permite se o colaborador vai ter acesso a visualizar as informações de Meus Links",
        //   selected: 0,
        //   checked: false,
        //   icon: 'fas fa-share-alt',
        //   error: false
        // },
        // {
        //   key: 'termosCondicoes',
        //   name: "Termos e Condições",
        //   description: "Lojista permite se o colaborador vai ter acesso a visualizar as informações de Termos e Condições",
        //   selected: 0,
        //   checked: false,
        //   icon: 'fas fa-file-alt',
        //   error: false
        // },
        // {
        //   key: 'privacidade',
        //   name: "Privacidade",
        //   description: "Lojista permite se o colaborador vai ter acesso a visualizar as informações de Privacidade",
        //   selected: 0,
        //   checked: false,
        //   icon: 'fas fa-lock',
        //   error: false
        // },
        // {
        //   key: 'politicaDevolucao',
        //   name: "Política de Devolução",
        //   description: "Lojista permite se o colaborador vai ter acesso a visualizar as informações de Política de Devolução",
        //   selected: 0,
        //   checked: false,
        //   icon: 'fas fa-shipping-fast',
        //   error: false
        // },
        // {
        //   key: 'notificacaoApp',
        //   name: "Notificação App",
        //   description: "Lojista permite se o colaborador vai ter acesso a visualizar as informações de Notificação App",
        //   selected: 0,
        //   checked: false,
        //   icon: 'fas fa-solid fa-bell',
        //   error: false
        // },
        // {
        //   key: 'notificacaoWhatsapp',
        //   name: "Notificação WhatsApp",
        //   description: "Lojista permite se o colaborador vai ter acesso a visualizar as informações de Notificação WhatsApp",
        //   selected: 0,
        //   checked: false,
        //   icon: 'fab fa-whatsapp',
        //   error: false
        // },
        // {
        //   key: 'agenteIa',
        //   name: "Agente IA",
        //   description: "Lojista permite se o colaborador vai ter acesso a visualizar as informações de Agente IA",
        //   selected: 0,
        //   checked: false,
        //   icon: 'fas fa-robot',
        //   error: false
        // },
        // {
        //   key: 'antifraude',
        //   name: "Antifraude",
        //   description: "Lojista permite se o colaborador vai ter acesso a visualizar as informações de Antifraude",
        //   selected: 0,
        //   checked: false,
        //   icon: 'far fa-credit-card',
        //   error: false
        // },
        // {
        //   key: 'orcamentoWhatsapp',
        //   name: "Orçamento WhatsApp",
        //   description: "Lojista permite se o colaborador vai ter acesso a visualizar as informações de Orçamento WhatsApp",
        //   selected: 0,
        //   checked: false,
        //   icon:"fas fa-hand-holding-usd",
        //   error: false
        // },
        // {
        //   key: 'orcamentos',
        //   name: "Orçamentos",
        //   description: "Lojista permite se o colaborador vai ter acesso a visualizar as informações de Orçamentos",
        //   selected: 0,
        //   checked: false,
        //   icon: 'fas fa-tags',
        //   error: false
        // },
      ],
    };
  },
  methods: {
    toggleOpen({ id, nameClerk, permission }) {
      this.menuPermission = JSON.parse(
        JSON.stringify(this.menuPermissionDefault)
      );
      this.open = !this.open;
      this.idUser = id;
      this.nameClerk = nameClerk;
      this.verifyPermission(permission);
    },

    permissionSelect(data, index) {
      this.menuPermission[index].selected = data.value;
      this.menuPermission[index].checked = data.selected;
    },

    save() {
      let data = [];
      let isError = false;

      this.menuPermission.forEach((element, index) => {
        if (element.checked && element.selected == '') {
          this.menuPermission[index].error = true;
          isError = true;
          return;
        }

        let result = {
          name: element.key,
          status: element.checked,
          type: element.selected,
          id_clerk: this.idUser,
        };

        data.push(result);
      });
      if (isError) {
        return;
      }

      data['id'] = this.idUser;

      const routeData =
        this.$route.meta.userType == UserTypes.BALCONISTA
          ? this.$store.dispatch('balconista/updatePermissionClerk', data)
          : this.$store.dispatch('shopkeeper/savePermission', data);

      this.loading = true;
      routeData
        .then((response) => {
          this.makeToast(
            'Sucesso',
            'Dados atualizados com sucesso!',
            'success'
          );
          this.$emit('clerkUpdate');
          this.open = !this.open;
        })
        .catch(() => {
          this.makeToast('Erro', 'Houve um erro ao trazer os dados', 'danger');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    verifyPermission(permission) {
      permission.forEach((element) => {
        this.menuPermission.find((menu, index) => {
          if (menu.key == element.name) {
            this.menuPermission[index].checked =
              element.status == 0 ? false : true;
            this.menuPermission[index].selected = element.type;
          }
        });
      });
    },
    closeModal() {
      this.open = false;
    },
  },
};
</script>
